import styled from 'styled-components'
import { black, blue, grey, lightGray } from '../../assets/ui/colors';

export const MainBlock = styled.div`
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid ${lightGray};
    border-radius: 4px;
    padding: 28px 24px;
    @media (max-width: 910px) {
        flex-direction: column;
    }
`;

export const InfoBlock = styled.div`
    width: 100%;
    margin-left: 50px;
    @media (max-width: 910px) {
        flex-direction: column;
        margin-left: 0;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 40px;
    line-height: 49px;
    letter-spacing: 0.15px;
    color: ${blue};
    margin-bottom: 24px;
    flex-wrap: wrap-reverse;
    & button {
        display: flex;
        height: fit-content;
        align-self: center;
        padding: 6px 16px;
        margin: auto 0;
        /* @media (max-width: 1024px) {
            display: none;
        } */
    }
    @media (max-width: 370px) {
        font-size: 24px;
    }
`;

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
`;

export const Label = styled.div`
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.250795px;
    color: ${grey};
`;

export const Text = styled.div`
    font-size: 16px;
    line-height: 22px;
`;

export const NextBtn = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    height: 64px;
    width: 240px;
    z-index: 13000;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 150px;
    }
`;

export const PrevBtn = styled.div`
    position: fixed;
    bottom: 0;
    left: ${props => props.openLeftMenu ? '255px' : 0};
    height: 64px;
    width: 145px;
    z-index: 13000;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 90px;
    }
`;

export const MobileHeader = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.15px;
    color: ${blue};
    margin-bottom: 24px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
    & button {
        color: white;
        margin: 0 5px;
    }
    & button.MuiButton-textSecondary {
        background: white;
        color: ${black};
    }
    @media (min-width: 600px) {
        margin-left: auto;
    }
`;

export const FinishCalendarImg = styled.div`
    background: ${props => props.backgroundUrl
        ? `url(${props.backgroundUrl})`
        : `white`
    };
    width: 220px;
    height: 220px;
    background-size: contain;
    background-repeat: no-repeat;
`;
